"use strict";

import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["children"];
import { invariant } from '@autoguru/utilities';
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const NextImagesContext = /*#__PURE__*/createContext(null);
export const useNextImages = (skipProviderCheck = false) => {
  const contextValue = useContext(NextImagesContext) || {
    placeholderImages: {}
  };
  !(contextValue !== null || skipProviderCheck) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Please have a <NextImageProvider /> set in your tree') : invariant(false) : void 0;
  return contextValue;
};
export const useNextPlaceholderFor = src => {
  const image = useNextImages(true);
  if (!image) return null;
  const {
    [src]: placeholderImage
  } = image['placeholderImages'];
  return placeholderImage;
};
export const NextImageProvider = _ref => {
  let {
      children
    } = _ref,
    value = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(NextImagesContext.Provider, {
    value: value,
    children: children
  });
};